<template>  
    <section>
		<div class="name">
			<input :placeholder="editName" :type="inputType" v-model="message"/>
		</div>
		
		<div class="submitBtn" @click="modifyUserInfo(flag)">确定</div>
		
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
    import utils from '@/assets/jslibs/utils'
	import {modifyUserInfo} from '@/api/common'
    export default {
        name: 'index',
		data(){
			return{
				inputType:"text",
				user_name:JSON.parse(sessionStorage.getItem("userInfo")).user_name,
				user_icon:JSON.parse(sessionStorage.getItem("userInfo")).user_icon, 
				qq:JSON.parse(sessionStorage.getItem("userInfo")).qq,
				wangwang:JSON.parse(sessionStorage.getItem("userInfo")).wangwang,
				flag:this.$route.query.flag,
				editName:"",
				uuid:this.$route.query.uuid,
				noticeFlag:false,
				message:""
			}
		},
        components: {
            CommonHeader,
        },
		
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
		
		mounted(){
			if(this.flag && this.flag=="qq"){
				this.editName = "请输入QQ";
                document.title = "编辑QQ";
				this.inputType = "tel"
			}else if(this.flag && this.flag=="wangwang"){
				this.editName = "请输入旺旺号";
                document.title = "编辑旺旺";
			}else{
				this.editName = "请输入名称";
                document.title = "编辑名称"
			}
		},
        
        methods: {
			//修改用户信息
			async modifyUserInfo(type){
				if(!this.message){
					window.toast("请输入修改后的信息","txt");
					return
				}
				
				if(type){
					var obj;
					switch(type){
						case "user_name":
							obj={user_name:this.message,user_icon:this.user_icon,qq:this.qq,wangwang:this.wangwang};
							break;
						case "user_icon":
							obj={user_name:this.user_name,user_icon:this.message,qq:this.qq,wangwang:this.wangwang};
							break;
						case "qq":
							obj={user_name:this.user_name,user_icon:this.user_icon,qq:this.message,wangwang:this.wangwang};
							break;
						case "wangwang":
							obj={user_name:this.user_name,user_icon:this.user_icon,qq:this.qq,wangwang:this.message};
							break;
						default:
							obj={user_name:this.user_name,user_icon:this.user_icon,qq:this.qq,wangwang:this.wangwang};
							break
					}
				}
			    const { data, status } = await modifyUserInfo(this.uuid,obj);
			    if (status !== 200) return 
				this.$router.push('./personal-data')
			},
        },
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';

    section{font-family:PingFangSC-Regular;font-weight:400;background: #fff}
	.name{margin:30px 24px 38px 24px;border-bottom: 1px solid #CFCFCF;}
	.name input{width: 100%;line-height: 40px;font-size: 14px;font-family: PingFangSC-Semibold;font-weight: 600;color: rgba(153,153,153,1);}
	.submitBtn{width:337.5px;height:46px;background:rgba(65,132,244,1);border-radius:2px;margin: 0 auto;line-height: 46px;text-align: center;font-size: 18px;color:rgba(255,255,255,1);}

</style>
